<template lang="pug">
  .claim-builder
    .form-container
      .sub-header--solid Request Claim Builder
      .form__inner-content
        .form-field-container
          .form-field-label Userinfo Claims
          json-linter(:model-value="userinfo"
                      @update:modelValue="onUpdate('userinfo', $event)")
        .form-field-container
          .form-field-label ID Token Claims
          json-linter(:model-value="id_token"
                      @update:modelValue="onUpdate('id_token', $event)")
</template>
<script>
import isEquals from 'lodash/isEqual';
import { JsonLinter } from '@/components';

export default {
  name: 'RequestClaimBuilder',
  components: {
    JsonLinter,
  },
  props: {
    modelValue: {
      type: Object,
      default: () => ({
        userinfo: {},
        id_token: {},
      }),
    },
  },
  emits: ['change'],
  data() {
    return {
      userinfo: JSON.stringify(this.modelValue.userinfo || {}, null, 2), // eslint-disable-line no-magic-numbers
      id_token: JSON.stringify(this.modelValue.id_token || {}, null, 2), // eslint-disable-line no-magic-numbers
    };
  },
  watch: {
    modelValue: {
      handler(newValue) {
        this.userinfo = JSON.stringify(newValue.userinfo || {}, null, 2); // eslint-disable-line no-magic-numbers
        this.id_token = JSON.stringify(newValue.id_token || {}, null, 2); // eslint-disable-line no-magic-numbers
      },
      deep: true,
    },
  },
  methods: {
    onUpdate(field, value) {
      try {
        const parsedValue = JSON.parse(value || '{}');
        // Let parent component know about the change if the parsed value is different
        if (isEquals(parsedValue, this.modelValue[field])) {
          this[field] = value;
        } else {
          this.$emit('update:modelValue', { ...this.modelValue, [field]: JSON.parse(value || '{}') });
        }
      } catch (e) {
        this[field] = value;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.form__inner-content {
  padding: 10px;
}
</style>
